<template>
	<component
		:is="isMobile ? 'k-topo-mobile' : 'k-topo-desktop'"
	>
		<template
			v-for="slot in slots"
			v-slot:[slot]
		>
			<slot :name="slot"></slot>
		</template>
	</component>
</template>

<script>
import { defineComponent } from 'vue'
import useMediaBreakpoint from '../../utils/media-breakpoints'

import KTopoMobile  from './KTopoMobile.vue'
import KTopoDesktop from './KTopoDesktop.vue'

const { Media } = useMediaBreakpoint()

export default defineComponent({
	name: 'KTopo',
	components: {
		KTopoMobile,
		KTopoDesktop,
	},
	computed: {
		isMobile() {
			return Media.isMobile
		},
		slots() {
			return Object.keys(this.$slots)
		}
	},
})
</script>
